<div class="ppl-mt20 p-4">
    <table class="table custom-font-size">
        <thead>
            <tr>
                <th style="background-color: #a8e4e14d; width: 10%;">Auth Number</th>
                <th style="background-color: #a8e4e14d; width: 10%;">Used Dollars</th>

            </tr>
        </thead>
        <tbody >
            <tr *ngFor="let entry of authData; let i = index">
                <td style="padding-left:24px;"   (click)="showDetails(entry)">
                    <span class="hyperlink">{{ entry.clientAuthNumber }}</span>
                </td>
                <td style="padding-left:24px; width: 50%;">
                    <span>{{ entry.usedUnits | number:'1.2-2' }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</div>